import {Box, HStack, Icon, Text} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {isNil} from 'ramda';

import {UserAbsenceResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {getUserName} from '@dms/shared';

import {parseDate} from 'shared/web';

interface PlannedAbsenceBannerProps {
  absence: UserAbsenceResponseBody | null;
}

export function PlannedAbsenceBanner(props: PlannedAbsenceBannerProps) {
  const format = useDateTimeFormatter();

  if (isNil(props.absence)) {
    return null;
  }

  const contact = props.absence.absenceContactUser;
  const deputyName = getUserName(contact) ?? contact?.email ?? '';

  return (
    <Box padding={2} borderRadius="small" backgroundColor="palettes.neutral.10.100">
      <HStack spacing={2} align="center">
        <Icon value="action/event" size={4} color="text.secondary" />
        <Text size="xSmall" color="secondary">
          {i18n.t('entity.userAbsence.labels.headerPlannedBanner', {
            date: format('dateMedium', parseDate(props.absence.dateFrom)),
            name: deputyName,
          })}
        </Text>
      </HStack>
    </Box>
  );
}
